"use client";

import { useEffect, useState } from "react";

interface VideoBannerProps {
  videoSrc: string;
  title: string;
  description: string;
}

export const VideoBanner = ({
  videoSrc,
  title,
  description,
}: VideoBannerProps) => {
  const [showLogo, setShowLogo] = useState(false);

  useEffect(() => {
    const timeout = setTimeout(() => {
      setShowLogo(true);
    }, 100); // slight delay to trigger transition
    return () => clearTimeout(timeout);
  }, []);

  return (
    <section className="relative w-full h-[80vh] overflow-hidden">
      <video
        className="absolute inset-0 w-full h-full object-cover"
        autoPlay
        muted
        loop
        playsInline
      >
        <source src={videoSrc} type="video/mp4" />
        Your browser does not support the video tag.
      </video>

      <div className="relative z-10 flex flex-col items-center justify-center h-full text-center bg-black/50 px-4">
        <h1
          className={`text-4xl text-[#f12924] md:text-6xl font-bold uppercase transition-opacity duration-3000 leading-tight ease-out ${
            showLogo ? "opacity-100" : "opacity-0"
          }`}
        >
          <p className="text-xl lg:text-2xl xl:text-4xl font-light xl:font-light text-pretty text-white">
            {description}
          </p>
          <div className="text-pretty">{title}</div>
        </h1>
      </div>
    </section>
  );
};
